import { Locale } from '@/setup/locales'
import { LOCALE_PREFIX_MAP } from '@/setup/routing'

const DOMAIN = process.env.NEXT_PUBLIC_DEPLOYMENT_URL || 'https://neotaste.com'

export const getDomain = (locale: Locale | 'base' | string) => {
    if (locale === 'base') return DOMAIN

    const localePrefix = LOCALE_PREFIX_MAP[locale as Locale]

    if (!localePrefix) return DOMAIN

    return `${DOMAIN}${localePrefix}`
}

export const createDomainUrl = (url: string, locale: Locale | 'base' | string) => {
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`

    return `${getDomain(locale)}${normalizedUrl}`
}

export const createHttpsUrl = (url: string) => {
    if (url.startsWith('http')) return url

    return `https://${url}`
}
